import script from "./UserOEM.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserOEM.vue?vue&type=script&setup=true&lang=ts"

import "./UserOEM.vue?vue&type=style&index=0&id=39938698&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39938698"]])

export default __exports__